import axios from 'axios';

export default async function getPerson( value, fieldId, formId ) {
    
    const ajaxUrl = gform_theme_config.common.form.ajax.ajaxurl;
    const data = new FormData();
    data.append('action', 'bravo_marknadsinformation_gf_get_person');
    data.append('personal_identity_no', value);
    
    data.append('field_id', fieldId);
    data.append('form_id', formId);
    
    return axios.post(ajaxUrl, data);
    
}
